import {LOCALE_CATEGORIES} from "@/assets/locales/categories.ts";
import {saveCoacheesListQuery} from "@/domains/-session/functions/coacheesListQuery";
import {customAsyncComponent} from "@/functions/customAsyncComponent";
import {GetWorkspaceCoachees, JourneyName, WorkspaceId} from "@/sdk.ts";
import {LocationQueryRaw, RouteLocationRaw, Router, RouteRecordRaw} from "vue-router";

export namespace AdminListRoute {
  export function record(): RouteRecordRaw {
    return {
      name: 'admin_list',
      path: '/workspace/:workspaceId/admin',
      component: customAsyncComponent(async () => import('./views/AdminListView.vue')),
      meta: {
        hasNav: true,
        requiresAuth: true,
        requiresAdmin: true,
        localeCategories: [
          LOCALE_CATEGORIES.ADMIN
        ],
        pageHeader: {
          showHome: false,
          showTitle: false,
          title: '',
          breadcrumb: []
        }
      },
    }
  }

  export function location(workspaceId: number): RouteLocationRaw {
    return {name: 'admin_list', params: {workspaceId}};
  }

  export function getParams(router: Router): { workspaceId: WorkspaceId; } {
    return {
      workspaceId: parseInt(router.currentRoute.value.params.workspaceId as string, 10),
    }
  }
}

export function getAdminListRouteLocation(workspaceId: number): RouteLocationRaw {
  return {name: 'admin_list', params: {workspaceId}};
}

export function getAdminListRouteParams(router: Router): { workspaceId: WorkspaceId; } {
  return {
    workspaceId: parseInt(router.currentRoute.value.params.workspaceId as string, 10),
  }
}